module.exports = ":host {\n\tflex: 1 0;\n\tdisplay: flex;\n\tflex-direction: row;\n}\n"